import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // Tailwind and global styles


// Restore deep-link path after Firebase Hosting 404.html → index.html bounce
try {
  const redirect = sessionStorage.getItem("spa-path-redirect");
  if (redirect && redirect !== "/" && redirect !== "/index.html") {
    sessionStorage.removeItem("spa-path-redirect");
    if (window.location.pathname + window.location.search + window.location.hash !== redirect) {
      window.history.replaceState(null, "", redirect);
    }
  }
} catch (_) {
  /* ignore */
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export default App;